import { useCallback, useEffect, useState } from "react";
import {
  getNotificationPermissionState,
  NOTIFICATION_PERMISSION_CHANGE_EVENT,
  type NotificationPermissionState,
} from "../../../services/firebase";

export function useNotificationPermissionState() {
  const [permissionState, setPermissionState] =
    useState<NotificationPermissionState | null>(null);
  const [isLoadingPermissionState, setIsLoadingPermissionState] =
    useState(true);

  const refreshPermissionState =
    useCallback(async (): Promise<NotificationPermissionState> => {
      const nextState = await getNotificationPermissionState();
      setPermissionState(nextState);
      setIsLoadingPermissionState(false);
      return nextState;
    }, []);

  useEffect(() => {
    const refresh = () => {
      void refreshPermissionState();
    };

    const refreshWhenVisible = () => {
      if (document.visibilityState === "visible") {
        refresh();
      }
    };

    refresh();
    window.addEventListener(NOTIFICATION_PERMISSION_CHANGE_EVENT, refresh);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refreshWhenVisible);

    return () => {
      window.removeEventListener(NOTIFICATION_PERMISSION_CHANGE_EVENT, refresh);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refreshWhenVisible);
    };
  }, [refreshPermissionState]);

  return {
    permissionState,
    isLoadingPermissionState,
    refreshPermissionState,
  };
}
